import { customElement, property } from "lit/decorators.js";
import { BaseComponent } from "../../base-component/base-component";
import { html } from "lit";

@customElement('mhecomm-product-card-image-display')
export class ProductCardImageDisplay extends BaseComponent {

  @property({ type: String })
  productImageUrl = '';

  @property({ type: String })
  productTitle = '';

  @property({ type: Boolean })
  lazyLoadImage = true;

  @property()
  containerStyle = 'product-card-image-container';

  @property()
  imageStyle = 'product-card-img';

  renderComp() {
    return html `
      <div class="${this.containerStyle}">
        <img 
          class="${this.imageStyle}"
          src="${this.productImageUrl}"
          alt=""
          loading="${this.lazyLoadImage ? 'lazy' : 'eager'}"
        />
      </div>`
  }

}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-product-card-image-display': ProductCardImageDisplay;
  }
}
